module.exports = __webpack_public_path__ + "media/St 4-keyboard-correct.ae7195eb.wav";